import React from "react";

const PermissionSwitch = ({ checked, onChange, disabled = false }) => {

    return (
         <label className="checkbox-wrapper-14">
            <input
                type="checkbox"
                className="switch"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
        </label>
    );
    
};

export default PermissionSwitch;
